import Core6Component from './Core6Component';
import Core6Utilities from './Core6Utilities';
import Core6RowAjax from "./Core6RowAjax";
import Core6Page from "./Core6Page";
import Core6PagedSlider from "./Core6PagedSlider";

export default class Core6OptionsLogic {
  static saveOptions(evt, options, componentId, rowId, pageId, optionsType) {
    Core6Utilities.getElement('.core_loading_anim_container').style.display = 'flex';

    //console.log('save all component options');
    //console.log(options);

    const optionsList = [];
    for (let i = 0; i < options.length; i += 1) {
      const option = options[i];
      const optionObj = {};
      switch (option.type) {
        case 'range':
          optionObj[option.name] = option.value;
          break;
        case 'radio':
          if (option.checked === true) {
            optionObj[option.name] = option.value;
          }
          break;
        case 'checkbox':
          if (option.checked === true) {
            optionObj[option.name] = option.value;
          } else {
            optionObj[option.name] = '';
          }
          break;
        default:
          if (option.classList.contains('colour_selector')) {
            if (option.classList.contains('selected')) {
              if (option.getAttribute('data-core6-component-param') !== undefined && option.getAttribute('data-core6-component-param') !== null) {
                optionObj[option.getAttribute('data-core6-component-param')] = option.getAttribute('data-core6-component-value');
              }
              if (option.getAttribute('data-core6-param') !== undefined && option.getAttribute('data-core6-param') !== null) {
                optionObj[option.getAttribute('data-core6-param')] = option.getAttribute('data-core6-value');
              }
              if (option.getAttribute('data-core6-page-param') !== undefined && option.getAttribute('data-core6-page-param') !== null) {
                optionObj[option.getAttribute('data-core6-page-param')] = option.getAttribute('data-core6-page-value');
              }
            }
          } else if (option.classList.contains('theme_preview')) {
            if (option.classList.contains('selected')) {
              if (option.getAttribute('data-core6-component-value') !== undefined && option.getAttribute('data-core6-component-value') !== null) {
                optionObj.theme = option.getAttribute('data-core6-component-value');
              }
              if (option.getAttribute('data-core6-value') !== undefined && option.getAttribute('data-core6-value') !== null) {
                optionObj.theme = option.getAttribute('data-core6-value');
              }
            }
          } else {
            optionObj[option.name] = option.value;
          }
          break;
      }
      if (Object.keys(optionObj).length !== 0 && optionObj.constructor === Object) {
        optionsList.push(optionObj);
      }
    }
    //console.log(optionsList);

    console.log(optionsList);

    if (optionsType === 'component') {
      Core6Component.changeComponentAttributes(componentId, optionsList, rowId);
    } else if (optionsType === 'block') {
      Core6RowAjax.changeBlockAttributes(rowId, optionsList, false);
    } else if (optionsType === 'pagedsliderblock') {
      Core6RowAjax.changeBlockAttributes(rowId, optionsList, true);
    } else if (optionsType === 'page') {
      // Save page options
      Core6Page.changePageAttributes(pageId, optionsList);
    }
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/core6/Core6OptionsLogic.js